// removed by extract-text-webpack-plugin
module.exports = {"table-row":"SortableHeader__table-row___2tavC"};